export enum Order{
    ASCENDING = 'Ascending',
    DESCENDING = 'Descending'
}